/* src/app/ai-sourcing/evaluation-slider/evaluation-slider.component.scss */
.exploring-evolution-criteria-card {
  border-radius: 12px;
  border: 2px solid #FFFFFF;
  background:
    linear-gradient(
      180deg,
      #F2F2F2 0%,
      #CDEDFF 100%);
  width: 100%;
  height: auto;
  padding: 15px;
}
.exploring-evolution-criteria-card .carousel-control-next::after,
.exploring-evolution-criteria-card .carousel-control-prev::after {
  font-size: 16px;
}
.exploring-evolution-criteria-card .carousel-indicators {
  bottom: -55px;
}
.exploring-evolution-criteria-card .carousel-control-prev {
  left: -5px;
  height: 15px;
  top: calc(100% + 18px);
}
.exploring-evolution-criteria-card .carousel-control-next {
  right: -5px;
  height: 15px;
  top: calc(100% + 18px);
}
.exploring-evolution-criteria-card .carousel-item {
  width: 100%;
  flex-wrap: wrap;
  padding-left: 0;
}
.exploring-evolution-criteria-card .carousel-inner {
  margin-bottom: 55px;
}
/*# sourceMappingURL=evaluation-slider.component-DRHAMYZ5.css.map */
